import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import './CoachingEnrollment.css';
import { CSVLink } from 'react-csv';
import axios from 'axios';
import { useUser } from '../context/UserContext';
import { hasPrivilege } from '../utils/hasPrivilege';
import { FiSearch } from 'react-icons/fi';
import { FiChevronDown,FiRefreshCw  } from 'react-icons/fi';
const CoachingEnrollment = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [enrollments, setEnrollments] = useState([]);
  const token = localStorage.getItem('auth-token');
  const { userData, selectedCenter } = useUser();

  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedEntryIndex, setSelectedEntryIndex] = useState(null);
  const [newStatus, setNewStatus] = useState('');
  const [remark, setRemark] = useState('');

  const headers = [
    { label: "Type", key: "type" },
    { label: "Sport", key: "sport" },
    { label: "Player Name", key: "playerName" },
    { label: "Mobile", key: "mobile" },
    { label: "Parent Mobile", key: "parentMobile" },
    { label: "Batch Name", key: "batchName" },
    { label: "Time", key: "session" },
    { label: "Amount", key: "amount" },
    // { label: "Payment Method", key: "paymentMethod" },
    // { label: "Status", key: "status" },
    { label: "Comments", key: "comments" }
  ];
  const [academyFilter, setAcademyFilter] = useState(null);
  const [sportFilter, setSportFilter] = useState(null);
  const [academyOptions, setAcademyOptions] = useState([]);
  const [sportOptions, setSportOptions] = useState([]);
  const [allAcademies, setAllAcademies] = useState([]);

  const [typeOptions, setTypeOptions] = useState([]);
  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);
  const [termOptions, setTermOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  useEffect(() => {
    const getUniqueOptions = (key) => {
      const uniqueSet = new Set(enrollments.map(item => item[key]).filter(Boolean));
      return Array.from(uniqueSet).map(value => ({ label: value, value }));
    };

    setTypeOptions(getUniqueOptions('type'));
    setPaymentMethodOptions(getUniqueOptions('paymentMethod'));
    setTermOptions(getUniqueOptions('termsAccepted'));
    setStatusOptions(getUniqueOptions('status'));
  }, [enrollments]);

  useEffect(() => {
    const getUniqueOptions = (key) => {
      const uniqueSet = new Set(enrollments.map(item => item[key]).filter(Boolean));
      return Array.from(uniqueSet).map(value => ({ label: value, value }));
    };

    setTypeOptions(getUniqueOptions('type'));
    setPaymentMethodOptions(getUniqueOptions('paymentMethod'));
    setTermOptions(getUniqueOptions('termsAccepted'));
    setStatusOptions(getUniqueOptions('status'));
  }, [enrollments]);

  const [typeFilter, setTypeFilter] = useState(null);
  const [paymentMethodFilter, setPaymentMethodFilter] = useState(null);
  const [termFilter, setTermFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const formatDate = (date) => date.toISOString().split('T')[0];
  const today = new Date();
  const tenDaysAgo = new Date(today);
  tenDaysAgo.setDate(today.getDate() - 10);

  const [startDate, setStartDate] = useState(formatDate(today));
  const [endDate, setEndDate] = useState(formatDate(today));

  useEffect(() => {
    const fetchAcademies = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await axios.get(process.env.REACT_APP_API_URL_ACADEMIES, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        });

        const fetched = res.data.data.academies;
        setAllAcademies(fetched);

        let options = fetched.map((academy) => ({
          label: academy.name,
          value: academy.id
        }));

        if (userData?.userType === 'ACADEMY' && Array.isArray(userData.academyIds)) {
          options = options.filter(opt => userData.academyIds.includes(opt.value));
        }

        setAcademyOptions(options);

        if (selectedCenter) {
          const defaultAcademy = options.find(opt => opt.value === Number(selectedCenter));
          if (defaultAcademy) {

            setAcademyFilter(defaultAcademy); 
          } else {
            console.error('No default academy found for selectedCenter:', selectedCenter);
          }
        }
      } catch (error) {
        console.error('Error fetching academies:', error);
        setError('Failed to load academies');
      }
      setLoading(false);
    };

    fetchAcademies();
  }, [selectedCenter]);


  const handleAcademyChange = (selected) => {
    setAcademyFilter(selected);
    setSportFilter(null);

    if (selected) {
      const selectedAcademy = allAcademies.find(a => a.id === selected.value);

      if (selectedAcademy && selectedAcademy.sports && Array.isArray(selectedAcademy.sports)) {
        const sportOptions = selectedAcademy.sports.map(sport => ({
          label: sport.name,
          value: sport.sport_id
        }));
        setSportOptions(sportOptions);
      } else {
        setSportOptions([]);
      }
    } else {
      setSportOptions([]);
    }
  };


  const [sortConfig, setSortConfig] = useState({
    key: 'amount',
    direction: 'asc',
    numericKeys: ['amount', 'discount']
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredEnrollments = enrollments.filter((entry) => {
    const searchStr = Object.values(entry).join(' ').toLowerCase();
    const matchesSearch = searchStr.includes(searchTerm.toLowerCase());

    const matchesType = !typeFilter || typeFilter.value === entry.type;
    const matchesPayment = !paymentMethodFilter || paymentMethodFilter.value === entry.paymentMethod;
    const matchesTerm = !termFilter || termFilter.value === entry.termsAccepted;
    const matchesStatus = !statusFilter || statusFilter.value === entry.status;
    const matchesSport = !sportFilter || sportFilter.label === entry.sport;


    return (
      matchesSearch &&
      matchesType &&
      matchesPayment &&
      matchesTerm &&
      matchesStatus &&
      matchesSport
    );
  });


  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig((prev) => ({
      ...prev,
      key,
      direction
    }));
  };


  const sortData = (data) => {
    const { key, direction, numericKeys } = sortConfig;
    return [...data].sort((a, b) => {
      const valA = a[key] || '';
      const valB = b[key] || '';

      if (numericKeys.includes(key)) {
        const numA = parseFloat(valA.replace(/[^\d.-]/g, '')) || 0;
        const numB = parseFloat(valB.replace(/[^\d.-]/g, '')) || 0;
        return direction === 'asc' ? numA - numB : numB - numA;
      }

      const strA = valA.toString().toLowerCase();
      const strB = valB.toString().toLowerCase();
      if (strA < strB) return direction === 'asc' ? -1 : 1;
      if (strA > strB) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const sortedEnrollments = sortData(filteredEnrollments);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedEnrollments.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedEnrollments.length / rowsPerPage);

  const handleItemsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageClick = (page) => setCurrentPage(page);
  const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  const handlePrevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  const generatePageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;
    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () =>
    generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">{page}</span>
      )
    );

  const totalEntries = filteredEnrollments.length;
  const indexOfFirstEntry = totalEntries > 0 ? indexOfFirstRow + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(indexOfLastRow, totalEntries) : 0;

  useEffect(() => {
    if (selectedCenter && allAcademies.length > 0) {
      const selected = allAcademies.find((a) => a.id === Number(selectedCenter));
      if (selected) {
        const selectedAcademyOption = {
          label: selected.name,
          value: selected.id
        };
        setAcademyFilter(selectedAcademyOption);
        if (selected.sports && Array.isArray(selected.sports)) {
          const sportOptionsFromSelected = selected.sports.map((sport) => ({
            label: sport.name,
            value: sport.sport_id
          }));
          setSportOptions(sportOptionsFromSelected);
        }

        fetchEnrollments();
      } else {
        setError('Selected center is not valid.');
      }
    } else if (!selectedCenter) {
      setError('Please select a center to view enrollments.');
    }
  }, [selectedCenter, allAcademies]);

  function formatTimeRange(range) {
    if (!range || !range.includes(" - ")) return null;

    const [start, end] = range.split(" - ");

    const format = (time) => {
      if (!time) return null;
      const [hours, minutes, seconds] = time.split(":");
      if (!hours || !minutes || !seconds) return null;

      const date = new Date();
      date.setHours(+hours, +minutes, +seconds);
      return isNaN(date) ? null : date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
    };

    const formattedStart = format(start);
    const formattedEnd = format(end);

    if (!formattedStart || !formattedEnd) return null;

    return `${formattedStart} - ${formattedEnd}`;
  }

  const fetchEnrollments = async () => {
    setLoading(true);
    setError('');
    try {

      let apiUrl;
      let academyQuery = '';


      const selectedAcademy = academyFilter?.value;

      if (userData?.userType === 'ACADEMY') {
        const allowedAcademies = selectedAcademy ? [selectedAcademy] : userData.academyIds;

        if (!allowedAcademies || allowedAcademies.length === 0) {
          setError('No academy access defined for this user.');
          setLoading(false);
          return;
        }

        academyQuery = `academyId=${allowedAcademies.join(',')}`;
      } else {
        academyQuery = selectedAcademy ? `academyId=${selectedAcademy}` : '';
      }

      apiUrl = `${process.env.REACT_APP_API_URL_WALKIN_RECORD}?${academyQuery}&startDate=${startDate}&endDate=${endDate}`;

      const res = await axios.get(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (res.status === 200) {
        const rawData = res.data.sportwiseReport;
        const formattedData = rawData.map((item) => ({
          type: item.type || '',
          sport: item.sportName || '',
          playerName: item.name || '',
          mobile: item.mobileNumber || '',
          parentMobile: item.parentMobileNumber || '',
          batchName: item.batchName || '',
          session: `${item.startTime || ''} - ${item.endTime || ''}`,
          coaching: item.isCoaching ? 'Yes' : 'No',
          discount: item.discount ? `${item.discount}%` : '0%',
          amount: item.amountCharged != null
            ? `₹${item.amountCharged}`
            : item.amountReceived != null
              ? `₹${item.amountReceived}`
              : '',
          paymentMethod: item.cash ? 'Cash' : item.razorpay ? 'Razorpay' : 'N/A',
          status: item.status || '',
          termsAccepted: item.term || '',
          remark: item.remarks || '',
          comments:item.comments || '',
        }));

        setEnrollments(formattedData);
      } else {
        setError('Failed to fetch data');
      }
    } catch (err) {
      console.error('Error fetching enrollments:', err);
      setError('Error fetching data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="enrollment-container">
      {/* Filters */}
      <div className="sales-filters-login">
        {/* Academy Filter */}
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${academyFilter ? "has-value" : ""}`}
            classNamePrefix="custom-react-select"
            options={academyOptions}
            value={academyFilter}
            onChange={handleAcademyChange}
            placeholder="All Academy"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}

          />
          {academyFilter && <label htmlFor="academyFilter">Academy</label>}
        </div>

        {/* Sport Filter */}
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${sportFilter ? "has-value" : ""}`}
            classNamePrefix="custom-react-select"
            options={sportOptions}
            value={sportFilter}
            onChange={setSportFilter}
            placeholder="Sport"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {sportFilter && <label htmlFor="sportFilter">Sport</label>}
        </div>

        {/* Type Filter */}
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${typeFilter ? "has-value" : ""}`}
            classNamePrefix="custom-react-select"
            options={typeOptions}
            value={typeFilter}
            onChange={setTypeFilter}
            placeholder="Type"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {typeFilter && <label htmlFor="typeFilter">Type</label>}
        </div>



        {/* Status Filter
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${statusFilter ? "has-value" : ""}`}
            classNamePrefix="custom-react-select"
            options={statusOptions}
            value={statusFilter}
            onChange={setStatusFilter}
            placeholder="Status"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {statusFilter && <label htmlFor="statusFilter">Status</label>}
        </div> */}

        {/* Date Filters */}
        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${startDate ? 'has-value' : ''}`}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{
              width: '90%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '14px',
              marginTop: '5px',
            }}
            onClick={(e) => e.target.showPicker()}
          />
          {startDate && <label>Start Date</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${endDate ? 'has-value' : ''}`}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{
              width: '90%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '14px',
              marginTop: '5px',
            }}
            onClick={(e) => e.target.showPicker()}
          />
          {endDate && <label>End Date</label>}
        </div>
        <div className="booking-control">
          <button
            className="search-button"
            onClick={fetchEnrollments}
            style={{
              padding: '8px',
              height: '38px',
              marginTop: '25px',
              backgroundColor: '#003b72',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              width: '38px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title="Search"
          >
            <FiRefreshCw  size={18} />
          </button>
        </div>
      </div>

      {/* Search & Per Page */}
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            className={`search-input ${searchTerm ? 'has-value' : ''}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">🔍 Search</label>
        </div>
        <CSVLink
          data={filteredEnrollments}
          headers={headers}
          filename="WalkinRecord.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>
      </div>
      
      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchEnrollments}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>

      </div>

      {/* Loading/Error States */}
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredEnrollments.length === 0 && (
        <div className="error-message">No data available</div>
      )}
      
      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''} ${sortConfig.key === key && sortConfig.direction === 'desc' ? 'desc' : ''}`}
                    />

                  </div>
                </th>
              ))}
              {/* {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'WALK_IN_SALES_RECORD_MODIFY') && (
                <th>Action</th>
              )} */}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((entry, index) => (
              <tr key={index}>
                <td>{entry.type}</td>
                <td>{entry.sport}</td>
                <td>{entry.playerName}</td>
                <td>{entry.mobile}</td>
                <td>{entry.parentMobile}</td>
                <td>{entry.batchName}</td>
                <td>
                  {formatTimeRange(entry.session)}
                </td>
                <td>{entry.amount}</td>
                {/* <td>{entry.paymentMethod}</td>
                <td>{entry.status}</td> */}
                <td>{entry.comments}</td>
                {/* {hasPrivilege(userData, 'CENTRE_MANAGEMENT', 'WALK_IN_SALES_RECORD_MODIFY') && (
                  <td className="action-buttons" style={{ borderBottom: "none" }}>
                    <button
                      className="edit-btn"
                      onClick={() => {
                        setSelectedEntryIndex(index);
                        setShowStatusModal(true);
                        setNewStatus('');
                        setRemark('');
                      }}
                    >
                      Update Status
                    </button>
                  </td>
                )} */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button className="prev-button" onClick={handlePrevPage} disabled={currentPage === 1}>Previous</button>
        {renderPagination()}
        <button className="next-button" onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
      </div>
      {showStatusModal && (
        <div
          className="status-modal-backdrop"
          onClick={() => setShowStatusModal(false)}
        >
          <div
            className="status-modal-box"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="status-modal-title">Update Status</h3>

            <label className="status-label">Status:</label>
            <div className="status-radio-group">
              <label className="status-radio-option">
                <input
                  type="radio"
                  name="status"
                  value="Verified"
                  checked={newStatus === "Verified"}
                  onChange={(e) => setNewStatus(e.target.value)}
                />
                Verified
              </label>
              <label className="status-radio-option">
                <input
                  type="radio"
                  name="status"
                  value="Unverified"
                  checked={newStatus === "Unverified"}
                  onChange={(e) => setNewStatus(e.target.value)}
                />
                Unverified
              </label>
            </div>

            <label className="status-label">Remark:</label>
            <textarea
              className="status-textarea"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Enter remark here"
            />

            <div className="status-modal-actions">
              <button
                className="status-btn confirm"
                onClick={() => {
                  setShowStatusModal(false);
                }}
              >
                Confirm
              </button>
              <button className="status-btn cancell" onClick={() => setShowStatusModal(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CoachingEnrollment;